import { Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    container: {
        flex: 1,
        marginTop: 17,
        paddingLeft: 20,
        paddingRight: 20
    },
    header: {
        fontSize: '48px!important',
        fontFamily: 'Spartan-bold',
        fontWeight: 400,
        lineHeight: 1.3,
        letterSpacing: '0em',
        color: '#212D40',
        textAlign: 'center'
    },
    img: {
        marginTop: 60,
        width: 495,
        height: 254,
        '@media (max-width: 1400px)': {
            width: 285,
            height: 166,
        },
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
}));

function PlanningStep5() {

    const classes = useStyles();

    return (
        <Grid container justifyContent={'center'} className={classes.container}>
            <Grid item lg={7} md={10} sm={12} className={classes.content}>
                <p className={classes.header}>
                  Thank you! <br/>
                  Our team will reach out<br/>
                  to help you soon!
                </p>

                <img
                    className={classes.img}
                    alt="{img}"
                    src={"/assets/icons/participant/participant_car.svg"}
                    />

            </Grid>
        </Grid>

    )
}

export default PlanningStep5;